import { AdapterBase, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { FunctionName } from "../function/FunctionRegistry";
export class StreamTextGenAdapter extends AdapterBase {
    constructor() {
        super(...arguments);
        this.functionName = FunctionName.textGeneration;
    }
    runResponseType() {
        return RunResponseType.STREAM;
    }
}
